import React, { useContext, useEffect } from "react";

import {
  CardHeader,
  Paper,
  Box
} from "@material-ui/core";

import { Card, Centered } from "../../../../../common/components/libs";
import PageStoreContext from "../context";
import useTopCategoriesStatsFetcher from "../hooks/useTopCategoriesStatsFetcher";
import { observer } from "mobx-react";
import NoTopCategoriesReport from "./NoTopCategoriesReport";
import {useTranslation} from "react-i18next";
import TopCategoriesTable from "./tables/TopCategoriesTable";
import TopCategoriesCards from "./cards/TopCategoriesCards";


const TopCategories = () => {
  const {t} = useTranslation(["general", "stats"]);

  const pageStore = useContext(PageStoreContext);
  const [isLoading, result, filter, setFilter] = useTopCategoriesStatsFetcher();


  useEffect(() => {
    if(!pageStore.currentMenu){
      return;
    }

    setFilter({
      fromDate: pageStore.from.toDate(),
      toDate: pageStore.to.toDate(),
      limit: 10,
      menuId: pageStore.currentMenu.id
    })
  }, [pageStore.currentMenu, pageStore.from, pageStore.to]);


  return (
    <Card mb={3}>
      <CardHeader
        title={t("stats:topCategories")}
      />
      {
        result.length > 0 && pageStore.generalStats ? <Paper>
              <Box display={{ xs: "none", sm: "block", md: "block", lg: "block", xl: "block" }}>
                <TopCategoriesTable result={result}/>
              </Box>
              <Box display={{ xs: "block", sm: "none", md: "none", lg: "none", xl: "none" }}>
                <TopCategoriesCards result={result}/>
              </Box>
        </Paper>
            :
            <Centered>
              <NoTopCategoriesReport/>
            </Centered>
      }
    </Card>
  );
};

export default observer(TopCategories)
